import {TextField} from "@mui/material";
import {FormField} from "hooks/useForm";
import {FC} from "react";

const PHONE_REGEX = /^\+[1-9]\d{9,14}$/; // Strict E.164 format

export const validatePhone = (value: string) => {
  if (value.length === 0) return "Phone number is required";

  if (value.length < 11 || value.length > 16)
    return "Phone must be 11-16 characters including country code";

  if (!PHONE_REGEX.test(value))
    return "Enter valid international format: +2xxxxxxxxxx (10-15 digits)";

  return undefined;
};

const PhoneInput: FC<FormField<string>> = ({value, error, onChange}) => (
  <TextField
    label="Phone Number"
    placeholder="e.g., +254123456789"
    value={value}
    onChange={e => onChange("+" + e.target.value.replace(/\D/g, ""))}
    error={!!error}
    helperText={error}
    fullWidth
    margin="normal"
    slotProps={{formHelperText: {sx: {marginLeft: 0}}}}
  />
);

export default PhoneInput;
